export function initializeLogoCarousel() {
    const carousels = document.querySelectorAll(".partners__carousel");

    carousels.forEach((carousel) => {
        if (carousel.dataset.initialized === "true") return;

        const original = carousel.querySelector(
            ".partners__carousel-inner"
        );

        if (!original) return;

        const copy = original.cloneNode(true);

        copy.setAttribute("aria-hidden", "true");
        carousel.appendChild(copy);

        carousel.dataset.initialized = "true";
    });
}